import {
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http'
import {
    ApplicationConfig,
    provideBrowserGlobalErrorListeners,
} from '@angular/core'
import {
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
} from '@angular/router'
import { TokenInterceptorFn } from '@mattrika/benefit-core'
import {
    BENEFIT_ENVIRONMENT,
    provideBenefitAppIcons,
} from '@mattrika/benefit-core'
import { provideSpartanHlm } from '@spartan-ng/helm/utils'
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@touhidrahman/ngx-common'
import { environment } from '../environment/environment'
import { appRoutes } from './app.routes'

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: BENEFIT_ENVIRONMENT, useValue: environment },
        { provide: ACCESS_TOKEN_KEY, useValue: 'benefitAccessToken' },
        { provide: REFRESH_TOKEN_KEY, useValue: 'benefitRefreshToken' },
        provideBrowserGlobalErrorListeners(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([TokenInterceptorFn]),
        ),
        provideRouter(
            appRoutes,
            withComponentInputBinding(),
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled',
            }),
        ),
        provideSpartanHlm(),
        provideBenefitAppIcons(),
    ],
}
